import React from 'react'
import Header from '../Header'
import { Link } from 'gatsby'
import ornament from './../assets/ornament1.svg'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './Polaroid.css'

class polaroid extends React.Component {
  constructor(props) {
    super(props)
    this.state = { width: 0, height: 0 }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  renderPolaroidStandard(items) {
    var polaroids = []
    var rowItems = []
    for (let itemIndex = 0; itemIndex < items.length; itemIndex++) {
      if (items[itemIndex].image) {
        //console.log(items[itemIndex]);
        //Its an image
        rowItems[itemIndex % 3] = (
          <div className="polaroid_col">
            <div className="polaroid_image_container">
              <img src={items[itemIndex].image} alt={`Product ${items[itemIndex].text}`}/>
              <div className="polaroid_image_caption">
                <h3>{items[itemIndex].text}</h3>
              </div>
            </div>
          </div>
        )
      } else if (items[itemIndex].action !== undefined) {
        //Its a button (action)
        rowItems[itemIndex % 3] = (
          <div className="polaroid_actions">
            <li>
              <Link
                to={items[itemIndex].action}
                className="polaroid_button"
              >
                {items[itemIndex].text}
              </Link>
            </li>
          </div>
        )
      }

      /* If its the second photo or the last one, close the row and reset the array */
      if (itemIndex % 3 === 2 || itemIndex === items.length - 1) {
        polaroids.push(<div className="polaroid_row">{rowItems}</div>)
        rowItems = []
      }
    }
    return polaroids;
  }

  renderPolaroidSlick(items){
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    };

    let polaroids = items.map(
      function(item){
        return <div className="polaroid_col">
        <div className="polaroid_image_container">
          <img src={item.image} alt={`Product ${item.text}`}/>
          <div className="polaroid_image_caption">
            <h3>{item.text}</h3>
          </div>
        </div>
      </div>
      }
    );

    return <Slider className="polaroid_row" {...settings}>{polaroids}</Slider>;
  }

  render() {
    let polaroids = (this.state.width > 900) ? this.renderPolaroidStandard(this.props.items) : this.renderPolaroidSlick(this.props.items)

    return (
      <div>
        <div className="polaroid_ornament">
          <img src={ornament} alt="ornament"/>
        </div>
        <div className="polaroid_row">
          <Header headerProps={this.props.headerProps} />
        </div>
        {polaroids}
      </div>
    )
  }
}

export default polaroid
